import { type FetchWalletTransferOutCostParams, type WalletFrontTransferOutRequest } from '@capsicum/common';

import { walletApi } from '.';

export async function fetchWalletTransferOutCost(query: FetchWalletTransferOutCostParams) {
	return (await walletApi)
		.fetchWalletTransferOutCost({
			...query
		})
		.then(res => res.data);
}

export async function postWalletTransferOut(payload: WalletFrontTransferOutRequest) {
	return (await walletApi).postWalletTransferOut(payload);
}
